import * as React from 'react'
import { connect } from 'react-redux'

import * as actions from 'embed/actions'
import { LoanStep, Product } from '@evenfinancial/even-ts-static'

import { MultiProductState } from 'embed/reducers'
import { ProductPicker } from './index'
import { DeepReadonly } from 'utility-types'
import {
  uiSelectedLoanStepSelector,
  uiSelectedProductSelector,
  uiViewportHeightSelector,
  uiViewportWidthSelector,
} from 'embed/selectors/ui'

interface StoreProps {
  availableProducts: DeepReadonly<Product[]>
  onApplicationStep: boolean
  selectedProduct?: Product
  viewportHeight?: number
  viewportWidth?: number
}

interface DispatchProps {
  dispatchProductSelected: (Product) => void
}

type ProductPickerProps = StoreProps & DispatchProps

const Container: React.FC<ProductPickerProps> = ({ dispatchProductSelected, ...props }) => {
  const onProductClick = React.useCallback(
    (product: Product) => {
      dispatchProductSelected(product)
    },
    [dispatchProductSelected],
  )

  const onProductSelect = React.useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      dispatchProductSelected(e.currentTarget.value)
    },
    [dispatchProductSelected],
  )

  return <ProductPicker onProductClick={onProductClick} onProductSelect={onProductSelect} {...props} />
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  availableProducts: state.ui.availableProducts,
  onApplicationStep: uiSelectedLoanStepSelector(state) === LoanStep.Application,
  selectedProduct: uiSelectedProductSelector(state),
  viewportHeight: uiViewportHeightSelector(state),
  viewportWidth: uiViewportWidthSelector(state),
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchProductSelected: (product) => dispatch(actions.productSelected(product)),
})

export const ProductPickerContainer = connect<StoreProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(Container)
